import { GO_LIVE_DATES } from '../content/dates'
import { OBSERVATORY_EDITIONS } from '../observatory/editions'
import { ThemeEntry } from '../types'
import { approvedContent, unreviewed } from './shared'

/** Slug of the GLP-1 hub, parent of molecule and brand pages in breadcrumbs (PRD §55). */
export const GLP1_HUB_SLUG = 'glp-1'

/** Approved hubs, themes and Observatório; publication authorized by the owner on 2026-10-14. */
export const THEMES: ThemeEntry[] = [
  { slug: GLP1_HUB_SLUG, name: 'GLP-1', themeType: 'hub' as const },
  { slug: 'canetas-emagrecedoras', name: 'Canetas emagrecedoras', themeType: 'theme' as const },
  { slug: 'consulta-emagrecimento-online', name: 'Consulta de emagrecimento online', themeType: 'theme' as const },
  { slug: 'dados', name: 'Observatório Medleve de GLP-1 no Brasil', themeType: 'data' as const }
]
  .map(({ slug, name, themeType }) => ({
    kind: 'theme' as const,
    slug,
    path: `/${slug}`,
    name,
    themeType,
    published: false,
    requiresReview: true,
    review: unreviewed()
  }))
  .map(approvedContent)

const edition = OBSERVATORY_EDITIONS[0]
const dataPage = THEMES.find((entry) => entry.slug === 'dados')!
Object.assign(dataPage, {
  published: true,
  title: edition.title,
  metaDescription: edition.description,
  shortAnswer: edition.description,
  review: { ...GO_LIVE_DATES, reviewer: 'carlos-seraphim', reviewStatus: 'approved', references: [] }
})
export const OBSERVATORY_ARCHIVES: ThemeEntry[] = OBSERVATORY_EDITIONS.map((edition) => ({
  ...dataPage,
  slug: `dados-glp-1-${edition.version}`,
  path: `/dados/glp-1/${edition.version}`,
  review: { ...dataPage.review, datePublished: edition.publicationDate!, dateModified: edition.publicationDate! }
}))
